import { useState } from 'react';

type CallbackFunction = () => void;

type ModalHookReturnType<T> = [boolean, (val?: T, callback?: CallbackFunction) => void, () => T | null];

const useModalV2 = <T>(data = false, defValue?: T): ModalHookReturnType<T> => {
  const [isShowing, setIsShowing] = useState<boolean>(data);
  const [value, setValue] = useState<T | undefined>(defValue);

  const toggle = (val?: T, callback?: CallbackFunction): void => {
    if (val) setValue(val);

    setIsShowing(!isShowing);

    if (callback && typeof callback === 'function') {
      callback();
    }
  };

  const getVal = () => value as T;

  return [isShowing, toggle, getVal];
};

export default useModalV2;
